export default class RequiredLicenses {
	prices: boolean;

	constructor(prices: boolean) {
		this.prices = prices;
	}
}
